import React from 'react';
import Row from 'react-bootstrap/Row';
import { Link } from 'react-router-dom';
import withContext from "../../withContext";

class Gallery extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            fadeIn: false
        };
    }

    importAll(r) {
        let images = {};
        r.keys().forEach((item) => {
            images[item.replace('./', '')] = r(item);
        });
        return images;
    }

    images = this.importAll(require.context('./GalleryPhotos', false, /\.(png|jpe?g|svg|jpg|JPG)$/));
    imageValues = Object.values(this.images);

    componentDidMount() {
        document.body.style.overflow = "visible";
        document.body.style.overflowX = "hidden";
        document.body.style.paddingTop = "6em";
        
        const prevPath = sessionStorage.getItem('prevPath') || '';
        const comingFromGalleryItem = prevPath.includes('/galleryitem/');
        
        if (!comingFromGalleryItem) {
            window.scrollTo(0, 0);
            setTimeout(() => this.setState({ fadeIn: true }), 50);
        } else {
            this.setState({ fadeIn: true });
        }
        
        this.props.context.refresh();
    }

    componentWillUnmount() {
        this.setState({ fadeIn: false });
        document.body.style.paddingTop = "0";
        
        if (!window.location.pathname.includes('/galleryitem/')) {
            sessionStorage.removeItem('prevPath');
        }
    }

    handleClick = () => {
        document.body.style.overflow = "hidden";
    }

    render() {
        const galleryPhotos = this.imageValues.map(value => value.default).reverse();

        return (
            <div style={{ maxWidth: '100%', overflowX: 'hidden' }}>
                <Row className={`justify-content-center mt-4 mb-4 page-transition gallery-container ${this.state.fadeIn ? 'fade-in' : ''}`}>
                    {galleryPhotos.map((item, index) => {
                        const itemIndex = galleryPhotos.indexOf(item);
                        return (
                            <div key={index} className="innerimg card-img m-2 card">
                                <img className="innerimg2 w-100 h-100" src={item} alt="Gallery item" />
                                <Link
                                    onClick={this.handleClick}
                                    className="clickasd position-absolute top-0 left-0 w-100 h-100"
                                    to={{
                                        pathname: `/galleryitem/${itemIndex + 1}`,
                                        about: {
                                            index: itemIndex,
                                            items: galleryPhotos
                                        }
                                    }}
                                />
                            </div>
                        );
                    })}
                </Row>
            </div>
        );
    }
}

export default withContext(Gallery);